import { desktopBreakpoint, Markdown, mobileBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

import styled, { AnyStyledComponent, css } from 'styled-components'

import CustomModal from '../../common/modal'

import { zIndexScale } from '../../../utils/style-utils'

import CancellationPolicyCrossIcon from '../../../assets/icons/filter-icons/cancellation-policy-overlay-cross.svg'
import FreeCancellationIcon from '../../../assets/icons/filter-icons/free-cancellation.svg'
import NewTagStarIcon from '../../../assets/icons/filter-icons/star.svg'

export const Container = styled.div`
    z-index: ${zIndexScale.largeTags.xxSmall};

    body.moreFilterClicked & {
        z-index: ${zIndexScale.largeTags.xlarge};
    }

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        position: fixed;
        top: 4rem;
        right: 1rem;
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 100%;
        position: sticky;
        background: ${({ theme }) => theme.colors.white};
        top: 4.0625rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        top: 5.0625rem;
    }
`

export const CancellationPolicyCloseIcon = styled(CancellationPolicyCrossIcon as AnyStyledComponent)`
    width: ${({ theme }) => theme.layout.xxSmall};
    height: ${({ theme }) => theme.layout.xxSmall};
`
export const CancellationPolicyHeader = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        padding: ${theme.spacing.medium} 0 ${theme.spacing.small} ${theme.spacing.medium};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            justify-content: flex-start;
            padding: ${theme.spacing.xLarge} 2.125rem 1.25rem;
            width: ${theme.layout.fill};
        }
    `,
)

export const CancellationPolicyIcon = styled(FreeCancellationIcon as AnyStyledComponent)`
    height: 1.3125rem;
    width: 1.3125rem;
    margin-right: 0.875rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        height: 1.75rem;
        width: 1.75rem;
    }
`
export const CancellationPolicyReadMoreModal = styled(CustomModal)(
    ({ theme }) => css`
        & .Overlay {
            background: #212121b3;
        }
        & .Modal {
            display: flex;
            flex-direction: column;
            padding: 0;
            border-radius: ${theme.typography.border.radius.xLarge} ${theme.typography.border.radius.xLarge} 0 0;

            @media only screen and (max-width: ${mobileBreakpoint.max}px) {
                left: 0;
                right: 0;
                bottom: 0;
            }

            @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                justify-content: center;
                align-items: center;
                border-radius: ${theme.typography.border.radius.xxLarge};
                background: ${theme.colors.white};
                width: ${theme.layout.fill};
                max-width: 39.25rem;
            }
        }
    `,
)

export const CancellationPolicyText = styled.strong(
    ({ theme }) => css`
        font: ${theme.typography.font.lato.weight.black} ${theme.typography.font.size.small} /
            ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            display: flex;
            flex: 1;
            letter-spacing: -0.0175rem;
            margin-right: ${theme.spacing.xxSmall};
            font-size: ${theme.typography.font.size.xLarge};
            line-height: ${theme.typography.font.size.xxLarge};
        }
    `,
)

export const StyledFilterAndSortSection = styled.div`
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.5rem;
        width: ${({ theme }) => theme.layout.fill};
        max-width: ${wideScreenBreakpoint.min}px;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 0;
        margin: 0 auto;
    }
`

export const PolicyPoints = styled(Markdown)(
    ({ theme }) => css`
        padding: 0 ${theme.spacing.medium} ${theme.spacing.large} 2.875rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 0 4.5rem 1.375rem;
        }

        & ul {
            padding: 0;
            color: #0000001a;
            font-size: ${theme.typography.font.size.small};
            line-height: ${theme.typography.font.size.xLarge};

            @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                font-size: ${theme.typography.font.size.medium};
            }

            & > li {
                padding-bottom: ${theme.spacing.xSmall};
                &::marker {
                    color: #0000001a;
                }
            }
        }
    `,
)

export const MobileFilterContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const NewTagContainer = styled.strong(
    ({ theme }) => css`
        display: flex;
        position: relative;
        margin: 0.375rem 0 0.375rem ${theme.spacing.xSmall};
        background-color: ${theme.colors.tfwRedOpacity08};
        border-radius: ${theme.typography.border.radius.xSmall};
        padding: ${theme.spacing.xxSmall} ${theme.spacing.xSmall};
        width: 2.625rem;
        height: 1.25rem;
        font-size: 0.6875rem;
        line-height: ${theme.typography.font.size.medium};
    `,
)

export const NewTagIcon = styled(NewTagStarIcon as AnyStyledComponent)(
    ({ theme }) => css`
        height: ${theme.spacing.xSmall};
        width: ${theme.spacing.xSmall};
    `,
)

export const NewTagText = styled.strong(
    ({ theme }) => css`
        letter-spacing: 0.025rem;
        text-transform: uppercase;
        color: ${theme.colors.tfwRed};
        font-size: 0.5625rem;
        line-height: ${theme.typography.font.size.medium};
    `,
)
